<div class="button_container">
    <div class="div_label">
        <div class="title">{{buttonTitle | translate}}</div>
        <!-- <div class="subtitle">{{buttonSubtitle | translate}}</div> -->
    </div>
    <div class="div_picto">
        <img class="picto" src={{picto}}>
    </div>
</div>